import NewDocumentDialog from './NewDocumentDialog.view';

export default NewDocumentDialog;
